import { Box, Typography, useTheme } from "@mui/material";
import { TreeItem, TreeItemProps } from "@mui/x-tree-view/TreeItem";
import React  from "react";
import { FilterNone, FilterNoneTwoTone } from "@mui/icons-material";
import { IOrganization } from "../../../services/organization-data-service/Models";


type OrganizationTreeItemProps = TreeItemProps & {
    showIcon?: boolean;
    navigationItem: IOrganization,
    onLabelClick?: (e: React.MouseEvent<Element, MouseEvent>) => void
};
  
export function OrganizationTreeItem(props: OrganizationTreeItemProps) {
    
    const theme = useTheme();
    const { navigationItem, 
            showIcon,
            onLabelClick,
            ...other
    } = props;


    return (
        <TreeItem 
        
            label={
                <Box 
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        //padding: theme.spacing(0.5, 0),
                    }}
                 onClick={onLabelClick}>

                    {showIcon ?
                             <FilterNoneTwoTone
                                sx={{
                                    marginRight: theme.spacing(1),
                                    fontSize: 'small'
                                }}
                                /> : 
                             <FilterNone 
                                sx={{
                                    marginRight: theme.spacing(1),
                                    fontSize: 'small'
                                }}
                             />
                    }

                    <Typography variant="body2" 
                        sx={{
                            fontWeight: 'inherit',
                            flexGrow: 1,
                        }}
                        >
                        {navigationItem.displayText}
                    </Typography>
                </Box>
            }
            {...other}
        />
    );
}

